<template>
	<div class="scrollable only-y">		
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-lock widget-icon accent-text fs-30"></i> {{ $t('menu.change_password') }}</h2>
		</div>
		<el-card>
			<template>
				<el-form label-position="left" :inline="true" status-icon :rules="rulesForm" ref="form" label-width="200px" :model="form">
						<el-col>
							<el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
								<el-form-item :label="$t('change_password.label.old_password')" prop="old_password">
									<el-input :type="form.passwordFieldType" required v-model="form.old_password" :placeholder="$t('change_password.placeholder.old_password')"/>
									<span style="float:right; cursor:pointer; z-index: 2;" type="password" class="visibility" tabindex='-1' @click='switchVisibility' :arial-label='passwordVisible ? "Hide password" : "Show password"'>
											<el-button class="mdi mdi-eye ps-r"></el-button>
									</span>
								</el-form-item>
							</el-col>
									<el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
										<el-form-item :label="$t('change_password.label.new_password')" prop="new_password">
											<el-input :type="form.passwordFieldTypeNew" required v-model="form.new_password" :placeholder="$t('change_password.placeholder.new_password')"/>
											<span style="float:right; cursor:pointer; z-index: 2;" type="password" class="visibility" tabindex='-1' @click='switchVisibilityNewPassword' :arial-label='passwordVisible ? "Hide password" : "Show password"'>
													<el-button class="mdi mdi-eye ps-npr"></el-button>
											</span>
											<small>Password strength:</small><el-progress :show-text="false" :percentage="passwordStrength.value" :status="passwordStrength.color" />
								</el-form-item>
							</el-col>
							<el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
								<el-form-item :label="$t('change_password.label.re_password')" prop="re_password">
									<el-input :type="form.passwordFieldRetypeNew" required v-model="form.re_password" :placeholder="$t('change_password.placeholder.re_password')"/>
									<span style="float:right; cursor:pointer; z-index: 2;" type="password" class="visibility" tabindex='-1' @click='switchVisibilityRetypeNewPassword' :arial-label='passwordVisible ? "Hide password" : "Show password"'>
											<el-button class="mdi mdi-eye ps-r"></el-button>
									</span>
								</el-form-item>
							</el-col>
							<el-col class="col-p">
								<el-form-item>
									<el-button type="primary" :loading="loadingBtnPassword" @click="changePassword">Save</el-button>
									<el-button>Cancel</el-button>
								</el-form-item>
							</el-col>
						</el-col>
					</el-form>
			</template>
		</el-card>
	
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
// import moment from 'moment-timezone'
const moment = require('moment')
const NodeRSA = require('node-rsa')
const key = new NodeRSA({b:512});
const pub = key.importKey(config.privateKey, 'pkcs1-public-pem');

export default {
	name: 'ChangePassword',
	data() {
		var checkHasValue = (rule, value, callback) => {
			var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[!@#\$%\^&\*]))|((?=.*[A-Z])(?=.*[!@#\$%\^&\*])))(?=.{6,})");

            if (!value) {
                return callback(new Error(this.$t('change_password.warning.null_'+rule.field)));
            } else if(value && value.length < 8 && rule.field != 'old_password') {
				return callback(new Error(this.$t('change_password.warning.min_'+rule.field)));
			} else if(mediumRegex.test(this.form.new_password) == false && rule.field == "new_password") {
				return callback(new Error(this.$t(`change_password.warning.not_strong`)))
			} else{
                callback()
            }
		}
		var validateRepassword = (rule, value, callback) => {
			if(value != this.form.new_password){
				return callback(new Error(this.$t('change_password.warning.not_match')));
			} else{
				callback()
			}
		}
		var validateOldNew = (rule, value, callback) => {
			if(this.form.old_password == this.form.new_password){
				return callback(new Error(this.$t('change_password.warning.same_with_old')));
			} else{
				callback()
			}
		}

		return {
			color: 'white',
			loadingBtnPassword: false,
			form: {
				old_password: "",
				new_password: "",
				re_password: "",
				passwordFieldType: 'password',
				passwordFieldTypeNew: 'password',
				passwordFieldRetypeNew: 'password'
			},
			passwordVisible:false,
			passwordStrength: {
				value: 0,
				color: 'exception'
			},
			rulesForm: {
				old_password:[
					{ validator: checkHasValue, trigger: 'blur' }
				],
				new_password:[
					{ validator: checkHasValue, trigger: 'blur' },
					{ validator: validateRepassword, trigger: 'blur' },
					{ validator: validateOldNew, trigger: 'blur' }
				],
				re_password:[
					{ validator: checkHasValue, trigger: 'blur' },
					{ validator: validateRepassword, trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		switchVisibility(){
			this.form.passwordFieldType = this.form.passwordFieldType === 'password' ? 'text' : 'password'
		},
		switchVisibilityNewPassword(){
			this.form.passwordFieldTypeNew = this.form.passwordFieldTypeNew === 'password' ? 'text' : 'password'
		},
		switchVisibilityRetypeNewPassword(){
			this.form.passwordFieldRetypeNew = this.form.passwordFieldRetypeNew === 'password' ? 'text' : 'password'
		},
		async changePassword(){	
			this.$refs['form'].validate(async (valid) => {
                if (valid) {
					this.loadingBtnPassword = true
					await api({
						method: 'post',
						url: config.baseApi + 'auth/change-password',
						timeout: 60 * 1000,
						data: {
							old_password: pub.encrypt(this.form.old_password, 'base64'),
							password: pub.encrypt(this.form.new_password, 'base64'),
							re_password: pub.encrypt(this.form.re_password, 'base64')
						}
					}).then(response => {
						this.loadingBtnPassword = false
						if(response.data.ec == 200){
							this.$swal(this.$t('success'), "Password has been changed", "success")
							this.form = {
								old_password: "",
								new_password: "",
								re_password: "",
								passwordFieldType: "password",
								passwordFieldTypeNew: "password",
								passwordFieldRetypeNew: "password"
							}
							this.$refs.form.clearValidate()
						} else{
							this.$swal(this.$t('error'), this.$t('change_password.warning.' + response.data.message), "warning")
						}
					}).catch(error => {
						this.loadingBtnPassword = false
						this.$swal(this.$t('error'), this.$t('error_text'), "warning")
					})
				} else{
					return false
				}
			})
		},
        
		go(url){
			this.$router.push(url);
		}
    },
	computed: {
		watchPasword(){
			return this.form.new_password
		}
	},
	watch: {
		watchPasword: function(){
			var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
			var mediumStrongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})");
			var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[!@#\$%\^&\*]))|((?=.*[A-Z])(?=.*[!@#\$%\^&\*])))(?=.{6,})");

			if(strongRegex.test(this.form.new_password)){
				this.passwordStrength.value = 100
				this.passwordStrength.color = 'success'
			} else if(mediumStrongRegex.test(this.form.new_password)){
				this.passwordStrength.value = 80
				this.passwordStrength.color = 'success'
			} else if(mediumRegex.test(this.form.new_password)){
				this.passwordStrength.value = 60
				this.passwordStrength.color = 'warning'
			} else {
				this.passwordStrength.value = this.form.new_password.length <= 4 ? this.form.new_password.length * 10 : 40
				this.passwordStrength.color = 'exception'
			}
		},
	}
}
</script>
<style>
.swal2-container {
  	z-index: 10000;
}
</style>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
.ps-r {
	padding:5px; 
	border: none; 
	position: absolute; 
	bottom: 6px; 
	right: -30px;
}
.ps-npr {
	padding:5px; 
	border: none; 
	position: absolute; 
	bottom: 50px; 
	right: -30px;
}
</style>